import React from "react";

const fmt = (n) => Number(n || 0).toLocaleString("tr-TR");
const trTarih = (s) => {
  if (!s) return "—";
  const p = String(s).slice(0, 10).split("-");
  return p.length === 3 ? `${p[2]}.${p[1]}.${p[0]}` : s;
};
const tipRenk = (t) =>
  t === "Horeca" ? "bg-sky-500/15 text-sky-300 border-sky-400/30"
  : t === "Fason" ? "bg-violet-500/15 text-violet-300 border-violet-400/30"
  : "bg-zinc-500/15 text-zinc-300 border-zinc-400/30";

export function SiparisDetay({ list }) {
  const rows = list || [];
  if (!rows.length) return <div className="py-3 text-center text-zinc-500 text-xs">Kayıt yok.</div>;
  return (
    <div className="rounded-md border border-white/10 overflow-x-auto">
      <table className="w-full text-xs">
        <thead>
          <tr className="bg-white/5 text-[9px] uppercase tracking-wider text-zinc-500">
            <th className="text-left px-3 py-2 font-semibold">Ürün Kodu</th>
            <th className="text-left px-3 py-2 font-semibold">Kalıp</th>
            <th className="text-left px-3 py-2 font-semibold">Renk</th>
            <th className="text-left px-3 py-2 font-semibold">Müşteri</th>
            <th className="text-left px-3 py-2 font-semibold">Tip</th>
            <th className="text-left px-3 py-2 font-semibold">Termin</th>
            <th className="text-right px-3 py-2 font-semibold">Kalan</th>
            <th className="text-right px-3 py-2 font-semibold">KG</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-white/5">
          {rows.map((o, i) => (
            <tr key={i} className="hover:bg-white/5">
              <td className="px-3 py-1.5 text-zinc-200 num">{o.urun_kodu || "—"}</td>
              <td className="px-3 py-1.5 text-zinc-400 num">{o.kalip_kodu || "—"}</td>
              <td className="px-3 py-1.5 text-zinc-400">{o.renk || "—"}</td>
              <td className="px-3 py-1.5 text-zinc-400">{o.musteri || "—"}</td>
              <td className="px-3 py-1.5">
                <span className={`inline-block px-1.5 py-0.5 rounded border text-[9px] font-semibold ${tipRenk(o.tip)}`}>{o.tip || "—"}</span>
              </td>
              <td className="px-3 py-1.5 text-zinc-400 num">{trTarih(o.termin_tarihi)}</td>
              <td className="px-3 py-1.5 text-right num font-semibold text-amber-300">{fmt(o.kalan)}</td>
              <td className="px-3 py-1.5 text-right num text-emerald-300/80">{fmt(o.kg)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default SiparisDetay;
